export default __webpack_public_path__ + "static/media/922.75f8fe7d.jpg";